<template>
  <UPopover v-model:open="popoverOpen" :popper="{ arrow: true, offsetDistance: 20 }">
    <button class="relative">
      <UIcon name="i-mdi-bell" dynamic class="text-[28px]"/>
      <div  v-if="newNotification" class="absolute top-0 right-0">
        <div class="animate-ping absolute top-0 right-0 bg-red-600 rounded-full w-3 h-3"/>
        <div class="absolute border-2 border-brand-gray top-0 right-0 bg-red-600 rounded-full w-3 h-3"/>
      </div>

    </button>
    <template #panel>
      <div class="w-[280px] max-h-[400px] overflow-auto">
        <div v-if="useNotifs().notifications.length == 0" class="text-brand-gray p-4">
          Pas de notifications
        </div>
        <Notification v-else v-for="notification in useNotifs().notifications">
          <div class="flex flex-col w-full" :class="notification.read ? 'opacity-50' : ''">
            <b>{{ notification.subject }}</b>
            {{ notification.message }}

            <div class="self-end text-sm underline text-brand-primary">
              <NuxtLink :to="`/${notification.suivi_id}`" v-if="notification.suivi_id">
                Voir
              </NuxtLink>
            </div>

          </div>

        </Notification>

      </div>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
import Notification from "~/components/header/Notification.vue";
import {updateNotifications} from "@directus/sdk";
import {useNotifs} from "~/store/notifs";

let popoverOpen = ref(false)

onMounted(() => {
  useNotifs().getNotifications()
})



const close = async () => {
  await useNotifs().getNotifications()
}

const open = async () => {
  const notifsToUpdateIds = useNotifs().notifications.filter((n) => n.read == false).map((n) => n.id)

  if (notifsToUpdateIds.length > 0) {
    await useDirectus().client.request(updateNotifications(notifsToUpdateIds, {read: true}));
  }
}

watch(() => popoverOpen.value, () => {
  if (popoverOpen.value) {
    open()
  } else {
    close()
  }
})

const newNotification = computed(() => {
  return useNotifs().notifications.filter((n) => n.read == false).length > 0
})
</script>

